import React from "react";
import PublicPage from "../../public/PublicPage";
import TransactionHistoryPage from "../../public/pages/TransactionHistoryPage";

const TransactionHistory = () => (
  <PublicPage>
    <TransactionHistoryPage />
  </PublicPage>
);

export default TransactionHistory;
